import moment from "moment";
import { toMoney } from "shared/utils";
import { ContentTitle } from "views/applications-id-report/components/ContentTitle";
import { KeyValue } from "views/applications-id-report/components/KeyValue";
import { PaystubDocument } from "views/applications-id-report/slices/CombinedIncomeReportSlice/types/verified/paystub";

export const IncomeDetailsSlice = ({
  paystub
}: {
  paystub: PaystubDocument;
}) => {
  return (
    <ContentTitle title="Income details" contentClassName="space-y-2">
      <KeyValue label="Employer name" value={paystub.employer} />

      <KeyValue
        label="Income start date"
        value={moment(paystub.start_date).format("ll")}
      />

      <KeyValue
        label="Income end date"
        value={
          paystub.end_date ? moment(paystub.end_date).format("ll") : "Present"
        }
      />

      <KeyValue
        label="Pay frequency"
        value={paystub.pay_stubs[0].paystub_details.pay_frequency || "-"}
      />

      <KeyValue label="Transaction count" value="wip be" />
      <KeyValue
        label="Monthly net income"
        value={toMoney(paystub.net_monthly_income_amount)}
      />

      <KeyValue
        label="Monthly gross income"
        value={toMoney(paystub.gross_monthly_income_amount)}
      />
    </ContentTitle>
  );
};
